export default "* Ask & Liv-lydfil ”Lyde fra jægerstenalderen”\n* Ask & Liv-ark ”Lyde fra jægerstenalderen”\n* Bluetooth højtaler\n* Blyant og papir\n\n";